window.addEventListener('load', () => {
  document.querySelectorAll('.bs-select-all').forEach((i) => {
    i.innerHTML = i18n('Select.all') || 'Select All';
  });

  document.querySelectorAll('.bs-deselect-all').forEach((i) => {
    i.innerHTML = i18n('Select.none') || 'Select None';
  });
  // Document.querySelectorAll('.btn-default').forEach(i => i.innerHTML = '<span class="filter-option pull-left">' + i18n('All') + '</span><span class="caret"></span>' || 'All');
});
